module.exports = __webpack_public_path__ + "static/media/zain.0783db40.jpg";